import { render, staticRenderFns } from "./SaleStatusBadge.vue?vue&type=template&id=2642abd8&scoped=true"
import script from "./SaleStatusBadge.vue?vue&type=script&lang=js"
export * from "./SaleStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./SaleStatusBadge.vue?vue&type=style&index=0&id=2642abd8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642abd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2642abd8')) {
      api.createRecord('2642abd8', component.options)
    } else {
      api.reload('2642abd8', component.options)
    }
    module.hot.accept("./SaleStatusBadge.vue?vue&type=template&id=2642abd8&scoped=true", function () {
      api.rerender('2642abd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/catalog/SaleStatusBadge.vue"
export default component.exports